import { RfidTagObject } from '@ng-cloud/badger-core/map/objects/rfid-tag-object';
import { RfidTag } from '@ng-cloud/badger-core/models/rfid-tag';
import { MapGrouping } from './map-grouping';
import { MapLayer } from './map-layer';

export class RfidTagGrouping extends MapGrouping<RfidTag, RfidTagObject> {

  constructor(public options: any = {}, public layerName: string = 'rfid_tags', public zIndex: number = 50) {
    super(options);

    this.layers = [new MapLayer(Object.assign({}, { name: layerName, zIndex: zIndex }, { grouping: this }))];
  }

  createObject(data: RfidTag): RfidTagObject {
    if (data.localized) {
      return new RfidTagObject(data, [this.storeMap.pointToPixels(data)], this.options);
    }
    else {
      return null;
    }
  }
}
